
















import Vue from 'vue'

interface Props {
  filterValue: string
}
interface Data {
  inputValue: Date
}

interface Methods {
  changeInput: () => void
}

export default Vue.extend<Data, Methods, {}, Props>({
  props: {
    filterValue: {
      required: true,
    },
  },
  data() {
    return {
      inputValue: new Date(),
    }
  },
  methods: {
    changeInput() {
      this.$emit('input', Math.floor(this.inputValue.valueOf() / 1000))
    },
  },
  mounted() {
    if (this.filterValue && this.filterValue.split('-').length === 1) {
      this.inputValue = new Date(Number(this.filterValue) * 1000)
    }
    this.changeInput()
  },
})
